import { UserDetailsFormStateUserEdit } from './UserDetailsFormStateUserEdit';

export class UserDetailsFormState {
  tenantUserEdit: UserDetailsFormStateUserEdit = new UserDetailsFormStateUserEdit();
}
